import { darkTheme } from './dark';
import { lightTheme } from './light';
import { createTheme, Theme } from '@fluentui/react';
import {
  BrandVariants,
  createDarkTheme,
  createLightTheme,
  Theme as NewTheme,
} from '@fluentui/react-components';

export interface AppTheme {
  base: typeof lightTheme | typeof darkTheme;
  fluent: Theme;
  newFluent: NewTheme;
}

export const getTheme = (theme: string): AppTheme => {
  switch (theme) {
    case 'dark':
      return {
        base: darkTheme,
        fluent: createTheme({ palette: darkTheme }),
        newFluent: customDarkTheme,
      };
    case 'contrast':
      return {
        base: darkTheme,
        fluent: createTheme({ palette: darkTheme }),
        newFluent: customDarkTheme,
      };
    default:
      return {
        base: lightTheme,
        fluent: createTheme({ palette: lightTheme }),
        newFluent: customLightTheme,
      };
  }
};

const bitTheme: BrandVariants = {
  10: '#050202',
  20: '#221311',
  30: '#3A1D1A',
  40: '#4D2422',
  50: '#622C29',
  60: '#773431',
  70: '#8D3B38',
  80: '#A44340',
  90: '#BB4B49',
  100: '#D25351',
  110: '#EA5C59',
  120: '#FF6865',
  130: '#FF847C',
  140: '#FF9D94',
  150: '#FFB4AC',
  160: '#FFCAC4',
};

const customLightTheme = createLightTheme(bitTheme);
const customDarkTheme = createDarkTheme(bitTheme);

customDarkTheme.colorBrandForeground1 = bitTheme[110];
customDarkTheme.colorBrandForeground2 = bitTheme[120];

customDarkTheme.colorNeutralBackground1 = darkTheme.white;
customLightTheme.colorNeutralBackground1 = lightTheme.white;

